<div class="welcome-new-user-dialog">
  <div class="dialog-header">
    <div>
      <h3 class="dialog-title">👋 Welcome to SuperSee, {{userName}}</h3>
      <span class="material-symbols-outlined" (click)="closeModal()">close</span>
    </div>
    <p class="dialog-paragraph" id="desktop-paragraph">
      Manage, monitor, and empower your team with confidence. Here's a quick walkthrough video to get you started.
    </p>
    <p class="dialog-paragraph" id="mobile-paragraph">
      Manage, monitor, and empower your team with confidence. Here's a quick walkthrough video to showcase powerful
      features of supersee.
    </p>
    <span class="tag-line" *ngIf="!data || !data.takeTour">🚀 Get your team's first screenshot in under 5
      minutes!</span>
  </div>
  <div class="dialog-content">
    <div class="video-container">
      <video #createNewEmployeeVideo src="../../../../assets/video/ss_new_employee_create.mp4" type="video/mp4" autoplay
        muted="muted" loop playsinline title="Create new employee video"
        [attr.id]="data && data.takeTour ? 'mobile-video' : 'desktop-video'"
        aria-label="Create new employee video of SuperSee" controls></video>
      <video #createNewEmployeeVideoMobileView
        src="https://supersee.io/wp-content/uploads/ss-videos/real-time-monitoring.mp4" type="video/mp4" autoplay
        muted="muted" loop playsinline title="Employee on boarding" class="mobile-video"
        aria-label="Employee on boarding video of SuperSee" controls></video>
    </div>
    <p class="dialog-paragraph">▶️ Watch this {{ data && data.takeTour ? '1 minute' : '45-seconds' }} walkthrough.</p>
    <p class="dialog-paragraph">Click 🔊 on the video to unmute it.</p>
  </div>

  <!-- Tabs -->
  <div class="tab-bar">
    <div [ngClass]="{'tab' : true, 'active': currentTab == 'tracking'}" (click)="currentTab = 'tracking'">Tracking</div>
    <div [ngClass]="{'tab' : true, 'active': currentTab == 'capture'}" (click)="currentTab = 'capture'">Capture</div>
    <div [ngClass]="{'tab' : true, 'active': currentTab == 'management'}" (click)="currentTab = 'management'">Management
    </div>
  </div>

  <!-- Feature Cards for tracking -->
  <div class="feature-cards" *ngIf="currentTab == 'tracking'">
    <div class="feature-card pink-theme">
      <span class="material-symbols-outlined feature-icon">schedule</span>
      <div class="feature-info">
        <div class="feature-title">Work Patterns <span class="badge">Realtime</span></div>
        <div class="feature-desc">View productive, idle & offline hours with detailed analytics.</div>
      </div>
    </div>
    <div class="feature-card blue-theme">
      <span class="material-symbols-outlined feature-icon">monitoring</span>
      <div class="feature-info">
        <div class="feature-title">App & Web Usage <span class="badge">2M+ Activities Tracked</span>
        </div>
        <div class="feature-desc">Track software and website usage with detailed activity breakdowns.</div>
      </div>
    </div>
  </div>

  <!-- Feature Cards for tracking -->
  <div class="feature-cards" *ngIf="currentTab == 'capture'">
    <div class="feature-card blue-theme">
      <span class="material-symbols-outlined feature-icon">photo_camera</span>
      <div class="feature-info">
        <div class="feature-title">Smart Screenshots <span class="badge">3-Way Capture</span></div>
        <div class="feature-desc">Capture periodic, app-change, or on-demand screenshots with custom intervals.</div>
      </div>
    </div>
    <div class="feature-card purple-theme">
      <span class="material-symbols-outlined feature-icon">cast</span>
      <div class="feature-info">
        <div class="feature-title">Live Screencast <span class="badge">Realtime</span>
        </div>
        <div class="feature-desc">Monitor screen activity in real time—securely and privately.</div>
      </div>
    </div>
  </div>

  <!-- Feature Cards for tracking -->
  <div class="feature-cards" *ngIf="currentTab == 'management'">
    <div class="feature-card purple-theme">
      <span class="material-symbols-outlined feature-icon">groups_2</span>
      <div class="feature-info">
        <div class="feature-title">Team Management <span class="badge">Unlimited Teams</span></div>
        <div class="feature-desc">Add unlimited teams, assign roles, and manage users across your organization.</div>
      </div>
    </div>
    <div class="feature-card blue-theme">
      <span class="material-symbols-outlined feature-icon">timeline</span>
      <div class="feature-info">
        <div class="feature-title">Auto Timesheets <span class="badge">Auto-Generated</span>
        </div>
        <div class="feature-desc">Generate precise timesheets from tracked data—no manual input needed.</div>
      </div>
    </div>
    <div class="feature-card pink-theme">
      <span class="material-symbols-outlined feature-icon">manage_accounts</span>
      <div class="feature-info">
        <div class="feature-title">Custom Employee Settings <span class="badge">Fully Customizable</span>
        </div>
        <div class="feature-desc">Set role-based permissions and tracking settings for each user.</div>
      </div>
    </div>
  </div>

  <div class="ruler"></div>
  <div class="dialog-footer" *ngIf="!data || !data.takeTour">
    <div class="cta">
      <button class="primary-cta" (click)="exploreNow()">Try it on this device</button>
      <small class="cta-note">Creates a test employee and downloads the app</small>
    </div>
    <!-- <div class="cta">
      <button class="secondary-cta" (click)="addFirstEmployee()">Add a teammate</button>
      <small class="cta-note">Use the full form to add a real employee</small>
    </div> -->
    <p>✨ It takes less than 2 minutes</p>
  </div>

  <!-- <div class="dialog-footer-tour" *ngIf="data && data.takeTour">
    <button (click)="skipTour()">Skip the tour</button>
    <button (click)="startTour()" [disabled]="isLoading">Start Tour</button>
  </div> -->

  <div class="explore-later" *ngIf="!data || !data.takeTour">
    <div class="reminder-text">
      Want to explore SuperSee later on desktop?
    </div>
    <div>
      <div class="or-container">
        <div class="lines"></div>
        <span>OR</span>
        <div class="lines"></div>
      </div>
      <div class="reminder-option-container-icons">
        <p>Set a reminder using your preferred calendar</p>
        <div>
          <a [href]="googleCalendarUrl" target="_blank"><img src="./../../../../assets/icons/google-calender.png"
              class="reminder-icon" alt="Google Calendar Icon"></a>
          <a [href]="outlookCalendarUrl" target="_blank"><img src="./../../../../assets/icons/outlook-calender.png"
              class="reminder-icon" alt="Outlook Calendar Icon"></a>
          <a (click)="downloadICSFile()"><img src="./../../../../assets/icons/apple-calender.png" class="reminder-icon"
              alt="Apple Calendar"></a>
          <a [href]="mailtoLink" class="email-link"><img src="./../../../../assets/icons/email.png"
              class="reminder-icon" alt="Email Icon"></a>
        </div>
      </div>
    </div>
    <!-- Mobile-specific CTA: email yourself a magic link for auto-login -->
    <button class="mobile-email-cta" *ngIf="isMobile" (click)="sendMobileEmail()"
      [disabled]="isMagicLinkButtonDisabled">
      <span *ngIf="!isMagicLinkButtonDisabled">Send me magic link for auto-login</span>
      <span *ngIf="isMagicLinkButtonDisabled">Resend in {{ getFormattedTimer() }}</span>
    </button>


  </div>
</div>